import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import { Breadcrumb, Col, Divider, Row, Tag } from "antd";
import Text from "antd/lib/typography/Text";

import Loader from "components/Loader/Loader";

import { fetchSurveyResponseDetailApi } from "utils/apiService";

import phoneNumber from "../../media/response-contact.svg";
import submittedBy from "../../media/response-user.svg";
import inaamCard from "../../media/response-card.svg";
import recScore from "../../media/response-recommendation.svg";
import moment from "moment";

const ResponseStats = (props) => {
	const responseStats = [
		{
			imgSrc: submittedBy,
			text: "Submitted By",
			data: props.loading ? "..." : props.data?.submitted_by,
		},
		{
			imgSrc: phoneNumber,
			text: "Phone Number",
			data: props.loading ? "..." : props.data?.contact_number,
		},
		{
			imgSrc: inaamCard,
			text: "Reward Card Number",
			data: props.loading ? "..." : props.data?.reward_card_number,
		},

		{
			imgSrc: recScore,
			text: "Recommendation Score",
			data: props.loading ? "..." : props.data?.recommendation_score,
		},
	];

	return (
		<>
			<Row
				type="flex"
				align="middle"
				style={{
					margin: "20px -10px",
					background: "#FFFFFF",
					border: "1px solid #E8E8E8",
					boxSizing: "border-box",
					borderRadius: "10px",
				}}>
				{responseStats.map((responseStat, index) => (
					<Col key={index} style={{ flexGrow: 1, flexBasis: 0 }}>
						<Row
							type="flex"
							gutter={[12, 12]}
							align="middle"
							style={{
								flexWrap: "nowrap",
								padding: "10px 20px",
							}}>
							<Col>
								<img
									src={responseStat.imgSrc}
									style={{
										width: "40px",
										height: "40px",
									}}
									alt={"Illustration"}
								/>
							</Col>
							<Col>
								<Text style={{ fontStyle: "normal", fontWeight: "normal", fontSize: "14px", lineHeight: "22px", color: "#747474" }}>
									{responseStat.text}
								</Text>
								<br />
								<Text
									style={{ fontSize: "16px", color: "#181818", fontWeight: "bold", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: 100 }}>
									{responseStat.data}
								</Text>
							</Col>
						</Row>
					</Col>
				))}
			</Row>
		</>
	);
};

const SurveyResponse = (props) => {
	const [loading, setLoading] = useState(true);

	const [responseDetail, setResponseDetail] = useState({
		response_details: [],
		submitted_by: "",
		contact_number: "",
		reward_card_number: "",
		recommendation_score: "",
		date_created: "",
	});

	const { formID, responseID } = useParams();

	useEffect(() => {
		setLoading(true);
		fetchSurveyResponseDetailApi({
			requestData: {
				uuid: responseID,
			},
			resCallback: () => {
				loading && setLoading(false);
			},
			res200Callback: (res) => {
				delete res.data.status;
				setResponseDetail({ ...res.data });
			},
			resErrorCallback: () => {
				props.history.go(-1);
			},
		});
	}, []);

	return loading ? (
		<Row type="flex" align="middle" justify="center" style={{ marginTop: "200px" }}>
			<Loader />
		</Row>
	) : (
		<>
			<Row type="flex" align="middle">
				<Text style={{ color: "#181818", /*fontFamily: "Gotham",*/ fontStyle: "normal", fontWeight: "bold", fontSize: "24px", lineHeight: "39px" }}>
					User Response Details
				</Text>
				<Divider type="vertical" style={{ margin: "0 12px", height: 24 }} />
				<Text color="green">{moment(responseDetail.date_created).format("DD/MM/YYYY")}</Text>
			</Row>
			<Breadcrumb style={{ margin: "12px 0" }} separator={<span style={{ color: "#747474" }}>{"<"}</span>}>
				<Breadcrumb.Item
					style={{ /*fontFamily: "Gotham",*/ fontStyle: "normal", fontWeight: "normal", fontSize: "14px", lineHeight: "22px", color: "#747474" }}>
					<Link to={"/app-feedback"}>Survey</Link>
				</Breadcrumb.Item>
				<Breadcrumb.Item
					style={{ /*fontFamily: "Gotham",*/ fontStyle: "normal", fontWeight: "normal", fontSize: "14px", lineHeight: "22px", color: "#747474" }}>
					<Link to={`/app-feedback/${formID}/responses`}>Form Details</Link>
				</Breadcrumb.Item>
				<Breadcrumb.Item
					style={{ /*fontFamily: "Gotham",*/ fontStyle: "normal", fontWeight: "normal", fontSize: "14px", lineHeight: "22px", color: "#464646" }}>
					User Response Details
				</Breadcrumb.Item>
			</Breadcrumb>
			<ResponseStats
				data={{
					submitted_by: responseDetail.submitted_by,
					contact_number: responseDetail.contact_number,
					reward_card_number: responseDetail.reward_card_number,
					recommendation_score: responseDetail.recommendation_score,
				}}
			/>
			<Row
				gutter={[32, 12]}
				style={{
					margin: "20px -10px",
					background: "#FFFFFF",
					border: "1px solid #E8E8E8",
					boxSizing: "border-box",
					borderRadius: "10px",
					padding: "12px 24px",
				}}>
				{responseDetail.response_details?.map((response) => (
					<div style={{ padding: "12px 0" }}>
						<Text style={{ fontSize: "16px", color: "#181818", fontWeight: "bold" }}>{response.question}</Text>
						<br />
						<Text style={{ fontSize: "16px", color: "#464646", marginTop: 8 }}>
							{response.answer}
							{response.type === "NPS Score" ? "/10" : null}
						</Text>
					</div>
				))}
			</Row>
		</>
	);
};

export default SurveyResponse;
